import { Address } from "viem";
import { Loan, LoanOptions } from "./Loan";
import { faker } from "@faker-js/faker";
import { externalWalletModule, verisModule } from "clients/verisModule";
import NftFactory from "../nft/NftFactory";
import { INft } from "../nft/INft";

export default class LoanFactory {
  static create({
    id,
    nfts,
    borrower,
    underlyingAsset,
    options,
  }: {
    id: Address;
    nfts: INft[];
    borrower: Address;
    underlyingAsset: Address;
    options?: LoanOptions;
  }): Loan {
    return new Loan({
      id,
      nfts,
      borrower,
      underlyingAsset,
      options,
    });
  }

  // static createRandomLoan(): Loan {
  //   const id: Address = `0x${faker.string.uuid()}`;
  //   const nfts: INft[] = Array.from(
  //     { length: faker.number.int({ min: 1, max: 5 }) },
  //     () => NftFactory.createRandomNft()
  //   );
  //   const borrower = externalWalletModule.address!;
  //   const underlyingAsset = verisModule.getContractAddress("wrappedToken");

  //   return this.create({
  //     id,
  //     nfts,
  //     borrower,
  //     underlyingAsset,
  //   });
  // }
}
